import styled from 'styled-components'

const StyledHeaderTabMenu = styled.div`
    margin-left: 80px;

    display: flex;
    justify-content: center;
    align-items: center;
`

export interface IHeaderTabMenuProps {
    className?: string
}

export const HeaderTabMenu: React.FC<IHeaderTabMenuProps> = ({ children }) => {
    return <StyledHeaderTabMenu>{children}</StyledHeaderTabMenu>
}

HeaderTabMenu.displayName = 'HeaderTabMenu'
